// Cuerpo del paso 02 cuando la verificación no avanzó: el motivo y la única acción que le toca.
import { AlertTriangle, X } from 'lucide-react';
import { Button } from '@/kit';
import { KYC_FAILURE_COPY } from '../kycFailure';
import type { KycFailure, KycModality } from '../types';
import { ModalityPicker, ScreenIntro, WaitingIcon } from './KycScreenBits';

export function KycFailureScreen({
    failure,
    tabletHint,
    phoneHint,
    retrying,
    finishing,
    onRetry,
    onFinish,
}: {
    failure: KycFailure;
    tabletHint: string;
    phoneHint: string;
    retrying: boolean;
    finishing: boolean;
    onRetry: (modality: KycModality) => void;
    onFinish: () => void;
}) {
    const copy = KYC_FAILURE_COPY[failure];

    if (copy.action === 'WAIT') {
        return (
            <div className="text-center">
                <WaitingIcon />
                <p className="mb-1 text-[15px] font-semibold">{copy.title}</p>
                <p className="mx-auto max-w-md text-[12.5px] leading-relaxed text-muted-foreground">
                    {copy.text}
                </p>
            </div>
        );
    }

    return (
        <div className="text-center">
            <ScreenIntro
                tone={copy.tone}
                icon={
                    copy.tone === 'danger' ? (
                        <X className="size-7" aria-hidden />
                    ) : (
                        <AlertTriangle className="size-7" aria-hidden />
                    )
                }
                title={copy.title}
                sub={copy.text}
            />

            {copy.action === 'RETRY' && (
                <ModalityPicker
                    tabletHint={tabletHint}
                    phoneHint={phoneHint}
                    loading={retrying}
                    onPick={onRetry}
                />
            )}

            {copy.action === 'SEND_LINK' && (
                <div className="flex flex-col items-center gap-2">
                    <Button
                        isLoading={retrying}
                        onClick={() => {
                            onRetry('CUSTOMER_LINK');
                        }}
                    >
                        Enviar link
                    </Button>
                    <Button
                        variant="outline"
                        size="sm"
                        isLoading={retrying}
                        onClick={() => {
                            onRetry('STORE_DEVICE');
                        }}
                    >
                        Reintentar en esta tablet
                    </Button>
                </div>
            )}

            {(copy.action === 'FINISH' || copy.action === 'FINISH_WITH_CANCEL') && (
                <Button isLoading={finishing} onClick={onFinish}>
                    Terminar
                </Button>
            )}
        </div>
    );
}
